module.exports = __webpack_public_path__ + "static/img/1.7848073.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R410A/1.jpg
// module id = N5ir
// module chunks = 1